import { Action } from '@ngrx/store';

export enum ActionTypes {
  SET_ACTIVE_ALERTS_SUB_SERVICE = 'SET_ACTIVE_ALERTS_SUB_SERVICE',
}

export class SetActiveAlertsSubService implements Action {
  constructor(public payload: string) {}
  readonly type = ActionTypes.SET_ACTIVE_ALERTS_SUB_SERVICE;
}

export type Actions = SetActiveAlertsSubService;
